import { render, staticRenderFns } from "./style-config.vue?vue&type=template&id=b7210a8a&"
import script from "./style-config.vue?vue&type=script&lang=js&"
export * from "./style-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports